export default {"src":"/_next/static/media/manage.88763249.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};